export const type = {
  SAVE_HEALTH_AND_SAFETY_REPORT: "SAVE_HEALTH_AND_SAFETY_REPORT",
  REMOVE_HEALTH_AND_SAFETY_REPORT:"REMOVE_HEALTH_AND_SAFETY_REPORT"
}
